import { motion } from "framer-motion";
import { TrendingUp, UserX, Puzzle, BarChart3 } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

export function PainSection() {
  const { t } = useLanguage();

  const painPoints = [
    {
      icon: TrendingUp,
      text: t("pain.point.1"),
    },
    {
      icon: UserX,
      text: t("pain.point.2"),
    },
    {
      icon: Puzzle,
      text: t("pain.point.3"),
    },
    {
      icon: BarChart3,
      text: t("pain.point.4"),
    },
  ];

  return (
    <section className="py-20 lg:py-32 relative">
      <div className="section-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            {t("pain.title")}
          </h2>
          <p className="text-xl lg:text-2xl text-primary">
            {t("pain.subtitle")}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {painPoints.map((point, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="card-surface p-6 flex items-start gap-4 hover-lift hover-glow"
            >
              <div className="icon-box shrink-0">
                <point.icon className="w-6 h-6" />
              </div>
              <p className="text-lg text-foreground font-medium">
                {point.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
